import { Button, ButtonProps } from '@progress/kendo-react-buttons'
import { useNavigate } from 'react-router-dom'

export interface GoBackButtonProps extends ButtonProps {
  delta?: number
}

export function GoBackButton(props: GoBackButtonProps) {
  const navigate = useNavigate()

  return (
    <Button {...props} onClick={() => navigate(props.delta ?? -1)}>
      {props.children}
    </Button>
  )
}
